import { TemplateResult, html, CSSResultGroup } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement } from 'lit/decorators.js';
import componentStyles from './ghs-formstack.css.lit';
import { LightController } from '../../controllers/light-controller';

/**
 * A wrapper to force our theme onto some formstack elements
 * @element ghs-formstack
 * @since 1.0.0
 * @slot - default slot
 */
@customElement('ghs-formstack')
export class GhsFormstack extends OutlineElement {
  static styles: CSSResultGroup = [OutlineElement.styles, componentStyles];

  lightController = new LightController(
    this,
    GhsFormstack.styles,
    this.tagName.toLowerCase()
  );

  render(): TemplateResult {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ghs-formstack': GhsFormstack;
  }
}
